import Image from 'next/image'
import { useTranslations } from 'next-intl'

import HeadingImage from '@/assets/images/storefronts/clashroyale/offers-heading.png'

import styles from './Offers.module.scss'

export const OffersHeader = () => {
  const t = useTranslations()
  return (
    <div id="offers" className={styles.headerContainer}>
      <div className={styles.imageContainer}>
        <Image src={HeadingImage} alt="offers-heading-image" fill quality={100} sizes="400px" />
        <div className={styles.headerText}>
          <h2>{t('offers_title')}</h2>
        </div>
      </div>
    </div>
  )
}
